export const LODGING_BENEFIT_ID = 'lodging'
export const TRAVEL_BENEFIT_ID = 'travel'
export const MALPRACTICE_BENEFIT_ID = 'malpractice'
export const CONTRACTING_ENTITY_AGENCY_ID = 'agency'

export const locumsContractingEntityOptions = [
  { id: CONTRACTING_ENTITY_AGENCY_ID, label: 'Agency' },
  { id: 'direct', label: 'Direct' },
]

export const locumsAgencyBenefitsOptions = [
  { id: LODGING_BENEFIT_ID, label: 'Lodging' },
  { id: TRAVEL_BENEFIT_ID, label: 'Travel' },
  { id: MALPRACTICE_BENEFIT_ID, label: 'Malpractice' },
]
